export const CHILDTABLE = {
  "Childtable.Cell.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Childtable.Header.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Childtable.Header.Color": {
    ref: "Color.Gray.800"
  },
  "Childtable.Header.Font.Size": {
    ref: "Font.Size.14"
  },
  "Childtable.Header.Icon.Color": {
    ref: "Color.Gray.700"
  },
  "Childtable.Header.Icon.Hover.Color": {
    ref: "Color.Gray.500"
  },
  "Childtable.Row.Expand.Color": {
    ref: "Color.Gray.700"
  },
  "Childtable.Cell.Selection.Color": {
    ref: "Color.Primary.500"
  },
  "Childtable.Cell.Readonly.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Childtable.Cell.Placeholder.Color": {
    ref: "Input.Cell.Placeholder.Color"
  },
  "Childtable.Footer.Bg.Color": {
    ref: "Color.Gray.100"
  }
};
